/**
 * CUSTOMER CHAT — the Inbox's third room, ready for the Customer Portal.
 *
 * Gerónimo (29 Oct 2026): «Mail · Kevo, chat interno y customer chat, que se
 * diferencien… conectado con el chat futuro del Customer Portal; déjamelo
 * armado, con un "very soon"». The switch, the place and the copy are here;
 * when the Customer Portal's chat exists, its conversations land in this pane.
 */
import type { ReactNode } from 'react';
import type { Lang } from '@/data/types';
import { KBIcon } from '@/components/kbIcons';

const T = (lang: Lang, en: string, es: string, fr: string, pt: string) =>
  lang === 'es' ? es : lang === 'fr' ? fr : lang === 'pt' ? pt : en;

export function CustomerChatSoon({ lang, switcher }: { lang: Lang; switcher?: ReactNode }) {
  return (
    <div className="ccs">
      <div className="ccs-top">{switcher}</div>
      <section className="ccs-card" aria-live="polite">
        <span className="ccs-ico"><KBIcon name="chat" size={26} /></span>
        <span className="ccs-soon">{T(lang, 'Very soon', 'Muy pronto', 'Très bientôt', 'Muito em breve')}</span>
        <h2>{T(lang, 'Customer chat', 'Chat con clientes', 'Chat clients', 'Chat com clientes')}</h2>
        <p>
          {T(lang,
            'The conversations clients start from the Customer Portal will arrive here — next to your mail and the team chat, each case’s messages in one place.',
            'Aquí llegarán las conversaciones que los clientes abran desde el Customer Portal — junto a tu correo y al chat del equipo, los mensajes de cada caso en un solo sitio.',
            'Les conversations que les clients ouvrent depuis le Customer Portal arriveront ici — à côté de votre courrier et du chat d’équipe.',
            'As conversas que os clientes abrirem no Customer Portal vão chegar aqui — junto ao seu correio e ao chat da equipa.')}
        </p>
      </section>
    </div>
  );
}
